import React from "react";
import PropTypes from "prop-types";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import { MdDeleteOutline, MdLogout } from "react-icons/md";

/**
 * 確認對話框 — 對應 DESIGN 稿的兩個 .el-overlay（登出確認 L2618-2627、
 * 毀損性操作確認 L2630-2639）。原本註解寫的 L910-L924 是看板欄，指到舊設計稿了。
 *
 * MUI Dialog。tone 決定圖示與確認鈕顏色：「danger」是紅色垃圾桶、其餘是登出箭頭。
 * 尺寸與字級由主題（theme/mui.js）決定，大字模式會跟著放大。
 */
function ConfirmDialog({ open, tone, title, subtitle, body, cancelText, confirmText, onCancel, onConfirm, icon }) {
  const danger = tone === "danger";

  return (
    <Dialog open={!!open} onClose={onCancel} maxWidth="xs" fullWidth role="alertdialog">
      <DialogTitle component="div" sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Avatar sx={{ bgcolor: danger ? "error.light" : "primary.light", color: danger ? "error.main" : "primary.main" }}>
          {icon || (danger ? <MdDeleteOutline /> : <MdLogout />)}
        </Avatar>
        <div>
          <Typography variant="h3" component="h2">
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          ) : null}
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText component="div">{body}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button variant="text" onClick={onCancel}>
          {cancelText}
        </Button>
        <Button variant="contained" color={danger ? "error" : "primary"} onClick={onConfirm}>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ConfirmDialog.propTypes = {
  open: PropTypes.bool,
  tone: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  body: PropTypes.node,
  cancelText: PropTypes.string,
  confirmText: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  icon: PropTypes.node,
};

ConfirmDialog.defaultProps = {
  open: false,
  tone: "danger",
  title: "",
  subtitle: "",
  body: "",
  cancelText: "取消",
  confirmText: "確定",
  onCancel: () => {},
  onConfirm: () => {},
  icon: null,
};

export default ConfirmDialog;
